<label class="subHeading">Plan Type</label>
<!-- <mat-select *ngIf="!isMultiSelect; else multi" formControlName="plan_type" class="plan_type" placeholder="Select">
    <mat-option *ngFor="let plan of plan_type" [value]="plan.rb_id">
      {{ plan.name }}
    </mat-option>
  </mat-select>
<ng-template #multi> -->
<app-search-dropdown
    [dataSearchKey]="'name'"
    [dataValueKey]="'rb_id'"
    [dataSource]="plan_type"
    [control]="plantypeControl"
></app-search-dropdown>
<!-- </ng-template> -->